import { render, staticRenderFns } from "./ChangePassword.vue?vue&type=template&id=b82024b4&"
import script from "./ChangePassword.vue?vue&type=script&lang=js&"
export * from "./ChangePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports